import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
export function GuaranteeSection() {
  return <section className="w-full border-y border-ink-800 bg-ink-900 py-16" aria-labelledby="garantia" data-id="element-111" data-mp="4uqcgsut9wrq">
      <div className="mx-auto flex w-full max-w-4xl flex-col items-start gap-6 px-4 sm:flex-row sm:items-center sm:px-6" data-id="element-112" data-mp="9tthweepe508">
        <span className="flex h-16 w-16 flex-none items-center justify-center rounded-2xl border border-gold bg-ink-950 text-gold" data-id="element-113" data-mp="euhbn7ubgzy5">
          <ShieldCheckIcon className="h-8 w-8" aria-hidden="true" data-id="element-114" data-mp="jqg3x6irn23u" />
        </span>
        <div data-id="element-115" data-mp="nskvlzpnlonu">
          <h2 id="garantia" className="font-display text-2xl font-900 uppercase tracking-wide text-white" style={{
          fontSize: "20px"
        }} data-id="element-116" data-mp="ns1ayb8mcm64">
            GARANTÍA 7 DÍAS — 
          </h2>
          <p className="mt-3 text-[15px] leading-relaxed text-slate-300" style={{
          fontSize: "14px"
        }} data-id="element-117" data-mp="xm1ngy68ctov">
            Abres los tomos. Los aplicas en tu proyecto. Si en 7 días no es exactamente lo que esperabas: devolución del 100% sin formularios, sin trámites, sin esperas. 
          </p>
          <p className="mt-2 text-sm text-slate-500" data-id="element-118" data-mp="25pucfke2c2la">Tasa de devoluciones: 0.8% (menos de 10 familias de 1.200+) ¿Por qué tan baja? Porque funciona.</p>
        </div>
      </div>
    </section>;
}